import * as ActionType from '../actionTypes/chat';
import axios from 'axios';
import getConfig from '../../config';
import {store} from '../store';
import * as ChatActions from '../actions/chat';
import firebase from "../../firebase/FirebaseProvider";

const addMessage = (state, data) => {
	return {
    ...state,
		messages: [
			...(state.messages || []),
			data
		]
	}
}

const fetchReactions = (state, payload={}) => {
	const { messageIds=[] } = payload;
	if (messageIds.length === 0) return;

	// TODO: Make a grouped call for all requests to save network time
	// and reduce number of calls.
	const arr = [];
	const config = getConfig();
	messageIds.forEach(messageId => {
		arr.push(new Promise((resolve, reject) => {
			axios.get(`${config.daisy.domain}${config.daisy.services.get_message_reactions}/${messageId}`)
				.then(resp => {
					const data = resp.data;
					resolve({
						messageId: messageId,
						reactions: data
					});
				})
				.catch(err => {
					reject(err);
				});
		}));
	})

	// TODO: This will fail if any call fails. Change it to address that.
	Promise.all(arr).then((values=[]) => {
		const result = {};
		for (let i = 0; i < values.length; i++) {
			const entry = values[i];
			const { messageId, reactions } = entry;
			const reactionCount = Object.keys(reactions).length;
			if (reactionCount > 0) {
				result[messageId] = reactions;
			}
		}
		store.dispatch(ChatActions.updateReactions(result));
	});
}

const registerReaction = (state, data) => {
  const config = getConfig();
  const url = `${config.daisy.domain}${config.daisy.services.post_message_reaction}`;

  let currentUser = firebase.auth().currentUser;
      if (currentUser) {
        currentUser.getIdToken()
          .then(idToken => {
            axios.post(url, data, {
                headers: { 'Authorization': 'Bearer ' + idToken }
            })
              .then(() => {
                store.dispatch(ChatActions.fetchReactions({
                  messageIds: [data.entity_id]
                }));
              })
              .catch(err => console.log(err));
          })
      }
}

const updateReactions = (state, data) => {
	const newState = {
    ...state,
		messages: [...state.messages || []],
		reactions: {
			...(state.reactions || {}),
			...data
		}
	}
	return newState;
}

const resetState = (state, data) => {
  return {
    ...state,
    messages: [],
    reactions: {}
  }
}

const updateUserState = (state, user={}) => {
    return {
      ...state,
      user: {...user}
    };
};

const setThemeImage = (state, data={}) => {
  return {
    ...state,
    general: {
      ...state.general,
      theme_image: data.theme_image
    }
  }
}

export default function reducer(state = {}, action) {
	if (action.type === ActionType.ADD_MESSAGE) {
		const addMessageResult = addMessage(state, action.payload);
		return addMessageResult;
	} else if (action.type === ActionType.FETCH_REACTIONS) {
		fetchReactions(state, action.payload);
	} else if (action.type === ActionType.UPDATE_REACTIONS) {
		return updateReactions(state, action.payload);
	} else if (action.type === ActionType.REGISTER_REACTION) {
    registerReaction(state, action.payload);
  } else if (action.type === ActionType.RESET_STATE) {
    return resetState(state, action.payload);
  } else if(action.type === ActionType.SET_USER_TO_STATE) {
	return updateUserState(state, action.payload);
  } else if(action.type === ActionType.SET_THEME_IMAGE) {
  return setThemeImage(state, action.payload);
  }
	return state;
}